<template>
	<div class="hello">
		<!--{{ $t("message.hello") }}-->
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueI18n from 'vue-i18n'
	Vue.use(VueI18n);
	export default {
		name: 'HelloWorld',
		data() {
			return {
				active: 0

			}
		},
		created() {
		},
		computed: {
			title() {
				return this.$store.state.title;
			}
		},
		methods: {
			tabchange() {
				this.$store.commit('cuurentTitle', "666");
				if(this.active == 1) {
					this.$router.push({
						path: '/home',
						params: {
							aa: 'xx',
							bb: 'xx'
						}
					});
					console.log(this.$route)
				}
			}
		}
	}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue